import { SVGProps } from 'react'

export const NeExcelSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <path
            d='m14.438 1.5 6 6v12.75a2.25 2.25 0 0 1-2.25 2.25H5.813a2.25 2.25 0 0 1-2.25-2.25V3.75a2.25 2.25 0 0 1 2.25-2.25h8.625Zm.347 8.052a.75.75 0 0 0-1.048.165l-1.691 2.321-1.69-2.321-.072-.085a.75.75 0 0 0-1.14.968l1.975 2.712-1.975 2.713-.059.095a.75.75 0 0 0 1.271.788l1.691-2.322 1.69 2.322.072.085a.75.75 0 0 0 1.141-.968l-1.976-2.713L14.95 10.6l.059-.095a.75.75 0 0 0-.224-.953Z'
            fill='#48A35F'
          />
          <path
            d='M14.438 1.5V6a1.5 1.5 0 0 0 1.5 1.5h4.5l-6-6Z'
            fill='#ACD5B7'
          />
        </g>
      </g>
    </svg>
  )
}
